import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  ClientRatingScopeType,
  GLOBAL_CLIENT_RATING_SCOPE_ID,
  type ClientRatingSnapshot,
} from "@fitness-app/data-models/entities/ClientRating";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_REDUCER_NAME } from "../types";

type Payload = {
  traineeId: string;
};

export const fetchClientRating = createAsyncThunk<ClientRatingSnapshot | null, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_REDUCER_NAME}/fetchClientRating`,
  async (payload, { rejectWithValue, extra: { db } }) => {
    const { data, error } = await db
      .from("client_rating_snapshot")
      .select("*")
      .eq("traineeId", payload.traineeId)
      .eq("scopeType", ClientRatingScopeType.Global)
      .eq("scopeId", GLOBAL_CLIENT_RATING_SCOPE_ID)
      .maybeSingle<ClientRatingSnapshot>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data;
  },
);
